import pino from "pino"

// Environment-specific configuration
const isDevelopment = process.env.NODE_ENV === "development"

// Base logger configuration
const baseLogger = pino({
  level: isDevelopment ? "debug" : "info",
  transport: isDevelopment
    ? {
        target: "pino-pretty",
        options: {
          colorize: true,
          translateTime: "SYS:standard",
          ignore: "pid,hostname",
        },
      }
    : undefined,
  browser: {
    asObject: true,
  },
})

// Create a logger function that allows for namespaced loggers
export const createLogger = (namespace: string) => {
  return baseLogger.child({namespace})
}

// Default logger
export default baseLogger

// Log level types for better type-safety
export type LogLevel = "trace" | "debug" | "info" | "warn" | "error" | "fatal"
